/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Shortcuts_TitleInputs */

const he_help_shortcuts_title = /** @type {(inputs: Help_Shortcuts_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`קיצורי מקלדת`)
};

const en_help_shortcuts_title = /** @type {(inputs: Help_Shortcuts_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keyboard Shortcuts`)
};

/**
* | output |
* | --- |
* | "Keyboard Shortcuts" |
*
* @param {Help_Shortcuts_TitleInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const help_shortcuts_title = /** @type {((inputs?: Help_Shortcuts_TitleInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Shortcuts_TitleInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_help_shortcuts_title(inputs)
	return en_help_shortcuts_title(inputs)
});